export const gradientOpacities = [0.20, 0.30, 0.45, 0.60, 0.75, 0.90, 1];
export function gradientOpacityRange(opacity) {
  return [opacity - 0.075, opacity + 0.075]; // 15% range (7.5% + 7.5%)
}
